/** Half of the Soft halo proposal's maximum opacity, held steady. */
export const CARD_READY_HALO_MAX_OPACITY = 0.14
export const CARD_READY_HALO_OPACITY = CARD_READY_HALO_MAX_OPACITY * 0.5
export const CARD_READY_COLORS = {
  light: { paper: '#f4ecd3', accent: '#607035', check: '#fff' },
  dark: { paper: '#2d351f', accent: '#a6bc65', check: '#18170f' },
} as const
